// ===== Packages =====

import React                                    from 'react';
import styled                                   from 'styled-components';
import { useSelected }                          from 'slate-react';

// ===== Services =====

import { setColorLightness }                    from '../../../services';

// ===== Constants =====

import {
    BODY_FONT_SIZE,
    POST_EDITOR_MAX_WIDTH,
    EDITOR_SELECTION_LIGHTNESS_VALUE,
    EDITOR_SELECTION_BORDER_THICKNESS,
}                                               from '../../../constants/generalConstants';

Divider.defaultProps = {
    readOnly: false,
};
interface Props {
    color: string,
    readOnly?: boolean,
    children: React.ReactElement,
    attributes: any,
}
function Divider({
    color,
    children,
    readOnly,
    attributes,
}: Props): JSX.Element {
    // ===== State =====
    const selected = useSelected();

    return (
        <Container
            {...attributes}
            color={color}
            selected={selected}
            readOnly={readOnly}
        >
            <Line />
            {children}
        </Container>
    );
}

// ===== Styled Components =====

interface ContainerProps {
    selected: boolean,
    color: string,
    readOnly: boolean,
}
const Container = styled.div<ContainerProps>`
    border: ${({ selected, color, theme }) => (selected
        ? `${EDITOR_SELECTION_BORDER_THICKNESS}px solid ${color
            ? setColorLightness(
                color,
                EDITOR_SELECTION_LIGHTNESS_VALUE,
            )
            : theme.color.cream400
        }`
        : 'none'
    )};
    border-radius: ${`${0.3125 * BODY_FONT_SIZE}px`};
    height: ${`${2.5625 * BODY_FONT_SIZE}px`};
    width: 90%;
    max-width: ${`calc(0.9 * ${POST_EDITOR_MAX_WIDTH}px)`};
    padding: ${`${1.25 * BODY_FONT_SIZE}px 0px`};
    margin: ${`${0.625 * BODY_FONT_SIZE}px auto`};
    clear: both;
    cursor: ${({ readOnly }) => (readOnly
        ? 'default'
        : 'cursor'
    )};
`;

const Line = styled.div`
    height: ${`${0.0625 * BODY_FONT_SIZE}px`};
    width: 100%;
    background-color: ${({ theme }) => theme.color.neutral300};
`;

export default Divider;
